import { getValue, stringValue } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
import { getExternalMedia } from "@nitro/gatsby-source-harvia-pim/helpers/media"
import React, { useContext } from "react"
import { PageContext } from "../../context/PageContext"
import { useUserPreferences } from "../../context/UserContext"
import useDatoMicrocopy from "../../hooks/useDatoMicrocopy"
import useProductPath from "../../hooks/useProductPath"
import { HarviaBackgroundColor } from "../layouts/BgColor"
import ProductCard from "../organisms/product/ProductCard"
import { ProductFilterProduct } from "../organisms/product/ProductFilter"
import { isAvailable } from "../organisms/product/utils"
import * as styles from "./ProductList.module.scss"

export type ProductListProps = { products: ProductFilterProduct[] }
/**
 * Simple product card renderer.
 * @param props products[]
 * @returns
 */
const ProductList: React.FC<ProductListProps> = props => {
  //console.log("Rendering ProductList", props)
  const userPrefs = useUserPreferences()
  const { locale } = useContext(PageContext)
  const t = useDatoMicrocopy("productFinder", locale)
  const getProductPath = useProductPath()
  const products = props.products

  return (
    <div>
      <ul className={styles.ul}>
        {products.map(product => {
          const val = (key: string) => stringValue(getValue(product.values, key))

          /** hakee masterImagen */
          const masterImage =
            product.media &&
            (product.media.find(img => img.masterImage) || getExternalMedia(product.media, "Product image")[0])

          /** tagit / ominaisuudet */
          const tags = [
            stringValue(getValue(product.values, "control_type")).split(", "),
            //   ...(getValue(product, "features_electric_heaters") || []),
          ]
            .flat()
            .filter(Boolean) //.map(itm => itm.label)

          /** Labelit tuotteen iän ja life cyclen perusteella */
          const labels: { label: string; color: HarviaBackgroundColor }[] = []

          // Tuotteen enabled tila on false, mutta silti tullut hakutuloksissa
          if (product.enabled === false) {
            labels.push({ label: t("labelDiscontinued", "Discontinued"), color: "BrandRed" })
          }

          // tuotteen lifecycle status
          const status = getValue(product.values, "product_life_cycle_status")
          switch (status?.value[0].data) {
            case "s0_concept_creation":
            case "s1_development":
              // case "gate_0_concepting":
              // case "gate_1_design_and_prototyping":
              // case "gate_2_development":
              // case "gate_3_go_to_market_support":
              // this should never happen anymore. See https://nitrogroup.atlassian.net/browse/HAR-445
              labels.push({ label: t("labelComingSoon", "Coming soon"), color: "BrandRed" })
              break

            case "s5_discontinued":
              // ei laiteta tuplana samaa labelia
              if (product.enabled !== false) {
                labels.push({ label: t("labelDiscontinued", "Discontinued"), color: "BrandRed" })
              }
              break

            case "s3_maintenance":
            case "s4_rampdown":
            default: {
              // uutuusaika 360 päivää
              const prod_date = getValue(product.values, "available_from_date")?.value[0].data
              if (!prod_date) break

              const newAtAge = 1000 * 60 * 60 * 24 * 360

              const age = Date.now() - Date.parse(prod_date)

              if (age && age < newAtAge) labels.push({ label: t("labelNew", "New"), color: "BrandRed" })
              break
            }
          }

          // varaosan tarvittava määrä
          if (product.quantityNeeded && product.quantityNeeded !== "1") {
            labels.push({
              label: `${product.quantityNeeded} ${t("labelUnitsNeeded", "pieces needed")}`,
              color: "BrandGreyWarmDark",
            })
          }

          const url = getProductPath(product.identifier)

          // ei buildattu tuote
          // if (~url.indexOf("?id="))
          //   labels.push({
          //     color: "BrandGreyWarmDark",
          //     label: t("labelUnavailable", "Unavailable"),
          //   })

          if (isAvailable(product, userPrefs.localeArea) === false) {
            labels.push({
              color: "BrandGreyWarmDark",
              label: t("labelUnavailable", "Unavailable"),
            })
          }
          return (
            <li key={product.identifier} className={styles.li}>
              <ProductCard
                image={masterImage?.thumbnail}
                imageAlt={masterImage?.name}
                group={val("product_group_2")}
                family={val("product_family")}
                title={val("product_marketing_name_short") || product.name || "Show product"}
                //text={val("marketing_text_short")}
                tags={tags}
                labels={labels}
                url={url}
                itemCode={val("item_code_harvia_finland") || product.identifier}
                wifi={getValue(product.values, "control_panel_type")?.value?.[0]?.data === "xenio_wifi"}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ProductList
